import React, { useEffect, useState } from 'react'

import {
  basicImageWithTextContainer,
  basicImageWithTextHeadingContainer,
  basicImageWithTextFlexContainer,
  basicImageWithTextLeft,
  basicImageWithTextRight,
  basicImageWithTextSubtext,
  basicImageWithTextFrontImage,
} from './index.module.css'

import { GatsbyImage } from "gatsby-plugin-image";
import useWindowSize from '../../hooks/useWindowSize'

const BasicImageWithText = ({ title, subtitle, images }) => {
  const size = useWindowSize()
  const [isMobile, setMobile] = useState(false)
  useEffect(() => {
    setMobile(size.width <= 767)
  }, [size.width])

  return title && subtitle && images ? (
    <div className="wrapper">
      <div className={basicImageWithTextContainer}>
        <div className={basicImageWithTextFlexContainer}>
          <div className={basicImageWithTextLeft}>
            {title && (
              <div className={basicImageWithTextHeadingContainer}>
                <h2>{title}</h2>
              </div>
            )}
            {subtitle && (
              <div
                className={basicImageWithTextSubtext}
                dangerouslySetInnerHTML={{
                  __html: subtitle?.childMarkdownRemark?.html,
                }}
              />
            )}
          </div>

          {images[0] && (
            <div className={basicImageWithTextRight}>
              <GatsbyImage
                image={images?.childImageSharp?.gatsbyImageData}
                className={basicImageWithTextFrontImage}
                alt={images[0]?.description}
                imgStyle={{
                  objectFit: 'contain',
                  objectPosition: `${isMobile ? `center` : `right`} bottom`,
                }} />
            </div>
          )}
        </div>
      </div>
    </div>
  ) : (
    <div></div>
  );
}

export default BasicImageWithText
